const ITEM_OPEN_CLASS = 'faq__item--open';

/**
 * @param {HTMLElement} item
 * @param {HTMLElement} answer
 * @param {HTMLButtonElement} trigger
 */
function openItem(item, answer, trigger) {
  item.classList.add(ITEM_OPEN_CLASS);
  trigger.setAttribute('aria-expanded', 'true');
  answer.toggleAttribute('inert', false);
  // eslint-disable-next-line no-param-reassign
  answer.style.maxHeight = `${answer.scrollHeight}px`;
}

/**
 * @param {HTMLElement} item
 * @param {HTMLElement} answer
 * @param {HTMLButtonElement} trigger
 */
function closeItem(item, answer, trigger) {
  item.classList.remove(ITEM_OPEN_CLASS);
  trigger.setAttribute('aria-expanded', 'false');
  answer.toggleAttribute('inert', true);
  // eslint-disable-next-line no-param-reassign
  answer.style.maxHeight = null;
}

/**
 * @param {HTMLElement} list
 * @param {HTMLElement} skipItem
 */
function closeAllExcept(list, skipItem) {
  list.querySelectorAll('[data-faq-item]').forEach((sibling) => {
    if (sibling === skipItem) return;
    if (!sibling.classList.contains(ITEM_OPEN_CLASS)) return;

    const siblingTrigger = sibling.querySelector('.faq__trigger');
    const siblingAnswer = sibling.querySelector('[data-faq-answer]');

    if (siblingTrigger && siblingAnswer) {
      closeItem(sibling, siblingAnswer, siblingTrigger);
    }
  });
}

/**
 * @param {NodeList} triggers
 * @param {HTMLButtonElement} current
 * @param {'prev'|'next'} direction
 */
function moveFocus(triggers, current, direction) {
  const arr = Array.from(triggers);
  const idx = arr.indexOf(current);

  if (direction === 'prev') {
    (arr[idx - 1] ?? arr[arr.length - 1]).focus();
  } else {
    (arr[idx + 1] ?? arr[0]).focus();
  }
}

document.querySelectorAll('[data-faq]').forEach((list) => {
  const triggers = list.querySelectorAll('.faq__trigger');

  list.querySelectorAll('[data-faq-item]').forEach((item) => {
    const trigger = item.querySelector('.faq__trigger');
    const answer = item.querySelector('[data-faq-answer]');

    if (!trigger || !answer) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains(ITEM_OPEN_CLASS);
      closeAllExcept(list, item);
      // eslint-disable-next-line no-unused-expressions
      isOpen ? closeItem(item, answer, trigger) : openItem(item, answer, trigger);
    });

    trigger.addEventListener('keydown', (e) => {
      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          moveFocus(triggers, trigger, 'next');
          break;
        case 'ArrowUp':
          e.preventDefault();
          moveFocus(triggers, trigger, 'prev');
          break;
        case 'Home':
          e.preventDefault();
          triggers[0]?.focus();
          break;
        case 'End':
          e.preventDefault();
          triggers[triggers.length - 1]?.focus();
          break;
        default:
          break;
      }
    });
  });
});
